module.exports = __webpack_public_path__ + "static/img/header-bg.b71d65f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header-bg.png
// module id = pZSb
// module chunks = 9